import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Livecoding 51: I did it! My first PR to a big OSS project \\o/",
  "description": "",
  "published": "2017-11-09T00:00:00.000Z",
  "redirect_from": ["/blog/livecoding-51-first-pr-big-oss-project/swizec/7914"],
  "categories": "Livecoding, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`This is a Livecoding Recap – an almost-weekly post about interesting things discovered while livecoding. Usually shorter than 500 words. Often with pictures. Livecoding happens almost `}<strong parentName="em">{`every Sunday at 2pm PDT`}</strong>{` on multiple channels. You should follow `}<a parentName="em" {...{
          "href": "https://www.youtube.com/TheSwizec"
        }}>{`My Youtube`}</a>{` channel to catch me live.`}</em></p>
    <lite-youtube {...{
      "videoid": "DFz5tHyhkw0",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`I did it! The `}<inlineCode parentName="p">{`gatsby-transform-remark`}</inlineCode>{` bug I've been working on for a month yields to my assault o/`}</p>
    <p>{`Not because it's `}<em parentName="p">{`that`}</em>{` difficult of a bug. Oh no. Because I was doing dumb things and jumping into a large project like Gatsby is hard.`}</p>
    <p>{`Previous attempts failed first because I couldn't get my dev environment to work and then because I made a newbie mistake with `}<inlineCode parentName="p">{`yarn.lock`}</inlineCode>{` and got frustrated. 😅`}</p>
    <p>{`👉 `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/livecoding-recap-48-why-contributing-to-big-opensource-projects/swizec/7848"
      }}>{`https://swizec.com/blog/livecoding-recap-48-why-contributing-to-big-opensource-projects/swizec/7848`}</a>{` 👉 `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/livecoding-recap-50-how-newbie-mistakes-kill-flow/swizec/7901"
      }}>{`https://swizec.com/blog/livecoding-recap-50-how-newbie-mistakes-kill-flow/swizec/7901`}</a></p>
    <p>{`The bug was more of a feature, really. When Remark generates a table of contents out of your markdown headers, it uses relative links. Like this 👇`}</p>
    <pre><code parentName="pre" {...{}}>{`# Heading

## Subheading 1

## Subheading 2

### Subsubheading

## Subheading 3
`}</code></pre>
    <p>{`That turns into an HTML list with `}<inlineCode parentName="p">{`#heading`}</inlineCode>{`, `}<inlineCode parentName="p">{`#subheading-1`}</inlineCode>{` (etc) links. Nesting at all.`}</p>
    <pre><code parentName="pre" {...{}}>{`- Heading (#heading)
  - Subheading 1 (#subheading-1)
  - Subheading 2 (#subheading-2)
    - Subsubheading (#subsubheading)
  - Subheading 3 (#subheading-3)
`}</code></pre>
    <p>{`Imagine all of that is HTML with `}<inlineCode parentName="p">{`<ul>`}</inlineCode>{` and `}<inlineCode parentName="p">{`<li>`}</inlineCode>{` and `}<inlineCode parentName="p">{`<a>`}</inlineCode>{` tags. Laying it out like this is easier to read.`}</p>
    <p>{`This works great when you're only putting tables of contents on each individual page. Render a markdown document, put a TOC on top. Perfect.`}</p>
    <p>{`But it stops working if you want to make a main table of contents for all your documents. All those relative links stop working. `}<inlineCode parentName="p">{`Subheading`}</inlineCode>{` is on an actual path now.`}</p>
    <p>{`The fix was to prepend slugs to every URL that `}<a parentName="p" {...{
        "href": "https://github.com/BarryThePenguin/mdast-util-toc"
      }}><inlineCode parentName="a">{`mdast-util-toc`}</inlineCode></a>{` generates. Best place to do that was deep inside `}<inlineCode parentName="p">{`gatsby-transform-remark`}</inlineCode>{`, in a file called `}<inlineCode parentName="p">{`extend-node-type.js`}</inlineCode>{`.`}</p>
    <p>{`As far as I can tell, that file is the whole of the markdown transformer. It takes a markdown GraphQL node (flat text at this point) and extends it into something Gatsby can read to make a React-based HTML page.`}</p>
    <p>{`Our fix went into the aptly named `}<inlineCode parentName="p">{`getTableOfContents`}</inlineCode>{` function.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const addSlugToUrl = function (node) {
  if (node.url) {
    node.url = withPrefix(\`\${markdownNode.fields.slug}\${node.url}\`);
  }
  if (node.children) {
    node.children = node.children.map((node) => addSlugToUrl(node));
  }

  return node;
};
tocAst.map = addSlugToUrl(tocAst.map);
`}</code></pre>
    <p>{`This happens after all the processing that turns a markdown file into an `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Abstract_syntax_tree"
      }}>{`abstract syntax tree (AST)`}</a>{`. Basic recursion 👇`}</p>
    <ul>
      <li parentName="ul">{`get node`}</li>
      <li parentName="ul">{`if node has `}<inlineCode parentName="li">{`url`}</inlineCode>{`, change it`}</li>
      <li parentName="ul">{`if node has children, call `}<inlineCode parentName="li">{`addSlugToUrl`}</inlineCode>{` to each`}</li>
    </ul>
    <p>{`Done 😁`}</p>
    <p>{`Looks simple now that it works, but it sure took a while. Large codebases are fun like that.`}</p>
    <p>{`Now just gotta figure out how to get `}<em parentName="p">{`absolute`}</em>{` absolute paths working. You know, when you're not deploying your site to `}<inlineCode parentName="p">{`/`}</inlineCode>{` but to `}<inlineCode parentName="p">{`/something/`}</inlineCode>{`. Something to do with the `}<inlineCode parentName="p">{`--prefix-paths`}</inlineCode>{` flag when compiling.`}</p>
    <p>{`Thanks to `}<a parentName="p" {...{
        "href": "https://twitter.com/lukeed05"
      }}>{`@lukeed05`}</a>{` for rubber ducking, and thanks to `}<a parentName="p" {...{
        "href": "https://twitter.com/kylemathews"
      }}>{`@kylemathews`}</a>{` for answering questions when I got stuck. ❤️`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      